import React from 'react';
import './StudyContentViewer.css';

// 스터디 상세 페이지에서 content를 template schema 기반으로 표시
// fields: TemplateField[]
// content: Record<string, unknown>
const StudyContentViewer = ({ fields = [], content = {} }) => {
  if (!fields.length) return null;

  return (
    <div className="scv-container">
      {fields.map((field) => (
        <div key={field.key} className="scv-field">
          <div className="scv-label">{field.label}</div>
          <div className="scv-value">
            {renderValue(field, content[field.key])}
          </div>
        </div>
      ))}
    </div>
  );
};

const renderValue = (field, value) => {
  if (value === undefined || value === null || value === '') {
    return <span className="scv-empty">-</span>;
  }

  switch (field.type) {
    case 'string':
      return (
        <p className="scv-text">
          {String(value).split('\n').map((line, i) => (
            <React.Fragment key={i}>
              {line}
              {i < String(value).split('\n').length - 1 && <br />}
            </React.Fragment>
          ))}
        </p>
      );

    case 'number':
      return (
        <span className="scv-number">
          {typeof value === 'number' ? value.toLocaleString() : value}
        </span>
      );

    case 'boolean':
      return (
        <span className={`scv-boolean ${value ? 'scv-boolean-true' : 'scv-boolean-false'}`}>
          {value ? '✓ 예' : '✗ 아니오'}
        </span>
      );

    case 'date':
      return <span className="scv-date">{value}</span>;

    case 'list':
      if (!Array.isArray(value) || value.length === 0) {
        return <span className="scv-empty">-</span>;
      }
      return (
        <ul className="scv-list">
          {value.map((item, i) => (
            <li key={i} className="scv-list-item">{item}</li>
          ))}
        </ul>
      );

    case 'object':
      if (typeof value !== 'object' || !field.fields?.length) {
        return <span className="scv-empty">-</span>;
      }
      return (
        <div className="scv-object">
          {field.fields.map((subField) => (
            <div key={subField.key} className="scv-object-row">
              <span className="scv-object-label">{subField.label}</span>
              <span className="scv-object-value">
                {renderValue(subField, value[subField.key])}
              </span>
            </div>
          ))}
        </div>
      );

    default:
      return <span className="scv-text">{String(value)}</span>;
  }
};

export default StudyContentViewer;
